import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const BONUSES = [{
  title: 'Checklist de señales',
  text: 'Detectá en una semana los momentos exactos en que tu autoexigencia se enciende.'
}, {
  title: 'Diario guiado de 7 días',
  text: '3 preguntas por día para observar tus patrones sin juzgarte.'
}, {
  title: 'Guion de pausa consciente',
  text: 'Una pausa de 5 minutos, lista para usar cuando el ritmo te sobrepasa.'
}];
export function Bonuses() {
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-14" data-mp="3o1lgyw505tlk">
      <div className="mx-auto max-w-5xl px-6" data-id="element-15" data-mp="3o369yhbo54hb">
        <SectionHeading eyebrow="De regalo" title="3 bonus incluidos" data-id="element-16" data-mp="3t0g4gbdx06c0" />
        <p className="mx-auto mt-5 max-w-xl text-center font-sans text-base leading-relaxed text-ink-soft" data-id="element-17" data-mp="3t2soqv75ass8">
          Herramientas prácticas para aplicar lo que aprendés desde el primer
          día.
        </p>
        <motion.figure initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mx-auto mt-12 max-w-3xl overflow-hidden bg-cream-deep" data-id="element-18" data-mp="3ieg938a9qf2y">
          <img src="https://cdn.magicpatterns.com/uploads/eiShVbrwSXRDS2ip6Rh72F/hf_20260716_002914_1b68626f-8859-4123-9240-6547a2166208.png" alt="Los tres bonus incluidos: checklist de autoexigencia, diario de 7 días y guion de pausa consciente" className="block aspect-[4/3] w-full object-cover" data-id="element-19" data-mp="2zgdco8fe5fv4" />
        </motion.figure>
        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-20" data-mp="npi3scdwrwsn">
          {BONUSES.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          ease: 'easeOut',
          delay: i * 0.1
        }} className="border border-sage/30 bg-cream-deep p-8 text-center" data-id="element-21" data-mp="irq0ynbq6q9o" data-mpi={i}>
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-sage text-cream" data-id="element-22" data-mp="2xu0ay5ct107g">
                <GiftIcon size={20} strokeWidth={1.6} data-id="element-23" data-mp="32slcc83slpxh" />
              </span>
              <h3 className="mt-6 font-serif text-2xl text-ink" data-id="element-24" data-mp="37jtkz1xat79l">{b.title}</h3>
              <p className="mt-3 font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-25" data-mp="37l4rvam1iv4x">
                {b.text}
              </p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-serif text-2xl italic text-ink" data-id="element-26" data-mp="2f27q4y7w2lat">
          Un compañero de lectura para bajar el ritmo, sin culpa.
        </p>
      </div>
    </section>;
}